// Миксин используется для использования клавиуатуры для навигации по таблице
// тендера и инкаминг тендера. Поддерживает стрелочки,
// поведение по энтеру (сохранение и переход на следующую ячейку) и таб.
import NAVIGATION_BUTTONS_KEY_CODES from '@/utils/constants/navigation-buttons';
import getSelection from '@/utils/get-selection';

const DIRECTIONS = {
  DOWN: 'down',
  UP: 'up',
  LEFT: 'left',
  RIGHT: 'right',
};

// Какое расстояние (в пикселях) от края начинает провоцировать скролл
const SCROLL_ACTIVATION_DELTA_Y = 100;
const SCROLL_ACTIVATION_DELTA_X = 150;

const tableNavigation = {
  data() {
    return {
      // Таб и стрелочки
      NAVIGATION_BUTTONS_KEY_CODES,
    };
  },
  methods: {
    // oldCellId это айдишник ячейки, с которой осуществялется перемещение,
    // требуется для вычисления нужного значения для скролла
    scrollTableHandler({ tableId, oldCellId, cellId, direction, toTheEnd = false }) {
      if (tableId && oldCellId && direction && cellId) {
        let table = document.getElementById(tableId);
        let tableCoords = table.getBoundingClientRect();

        // В проекте логика экшенов завязана на ячейке, в тендерах логика завязана на значении, так как в ячейке
        // есть еще много чего кроме самого значения, поэтому в тендерах берем айдишник враппера, а в проекте обычный
        let oldCellWrapper = document.getElementById(`${oldCellId}-wrapper`);
        let oldCellContent = document.getElementById(`${oldCellId}`);
        let oldComputedCell = oldCellWrapper || oldCellContent;
        let oldCellCoords = oldComputedCell.getBoundingClientRect();

        let cellWrapper = document.getElementById(`${cellId}-wrapper`);
        let cellContent = document.getElementById(`${cellId}`);
        let computedCell = cellWrapper || cellContent;
        let cellCoords = computedCell.getBoundingClientRect();

        // Флаг toTheEnd делает перемещение фокуса в конец/начало строки/столбца
        switch (direction) {
          case DIRECTIONS.DOWN:
            if (toTheEnd) {
              table.scrollTop =
                cellCoords.top - table.offsetHeight + table.scrollTop + SCROLL_ACTIVATION_DELTA_X;
            } else if (cellCoords.bottom > tableCoords.bottom - SCROLL_ACTIVATION_DELTA_Y) {
              table.scrollTop = table.scrollTop + cellCoords.bottom - oldCellCoords.bottom;
            }
            break;
          case DIRECTIONS.UP:
            if (toTheEnd) {
              table.scrollTop =
                cellCoords.top - tableCoords.top + table.scrollTop - SCROLL_ACTIVATION_DELTA_Y;
            } else if (cellCoords.y < tableCoords.y + SCROLL_ACTIVATION_DELTA_Y) {
              table.scrollTop = table.scrollTop - (oldCellCoords.top - cellCoords.top);
            }
            break;
          case DIRECTIONS.LEFT:
            if (toTheEnd) {
              table.scrollLeft = 0;
            } else if (cellCoords.x < tableCoords.x + SCROLL_ACTIVATION_DELTA_X) {
              table.scrollLeft = table.scrollLeft - (oldCellCoords.left - cellCoords.left);
            }
            break;
          case DIRECTIONS.RIGHT:
            if (toTheEnd) {
              table.scrollLeft =
                cellCoords.left - table.offsetWidth + table.scrollLeft + SCROLL_ACTIVATION_DELTA_X;
            } else if (cellCoords.right > tableCoords.right - SCROLL_ACTIVATION_DELTA_X) {
              table.scrollLeft = table.scrollLeft + cellCoords.right - oldCellCoords.right;
            }
            break;
        }
      }
    },
    // Цель метода - по типу операции и текущей локации определить следующую локацию фокуса
    // для перемещения по ячейкам таблицы (стрелочки, табы и прочее)
    getNextPositionIdByLocationAndEvent({
      event,
      rowsIds = [],
      fields = [],
      currentRowId,
      currentField,
      isBreakdown = false,
      value = '',
      tableId,
    }) {
      const currentFieldIndex = fields.findIndex((field) => field === currentField);
      const currentRowIndex = rowsIds.findIndex((rowId) => rowId === currentRowId);
      let fieldCompositeKey = currentField;
      let rowIdCompositeKey = currentRowId;
      // По ходу выполнения функции мы модернизируем старый айдишник новый,
      // поэтому место вызова этой функции играет роль
      const getCellId = () => {
        return `${+isBreakdown}${fieldCompositeKey}${rowIdCompositeKey}`;
      };
      let scrollTableParams = {
        tableId: tableId,
        oldCellId: getCellId(),
      };
      // Если все значение яченйки не в фокусе, то стрелочки будут двигать каретку, иначе менять фокус ячеек
      if (getSelection({ isClear: true }) === value.replace(/\s/g, '')) {
        switch (event.key) {
          case 'ArrowLeft':
            if (currentFieldIndex >= 1) {
              fieldCompositeKey = event.metaKey ? fields[0] : fields[currentFieldIndex - 1];
              this.scrollTableHandler({
                ...scrollTableParams,
                cellId: getCellId(),
                direction: DIRECTIONS.LEFT,
              });
            } else {
              fieldCompositeKey = event.metaKey ? fields[0] : fields[fields.length - 1];
              if (!event.metaKey) {
                this.scrollTableHandler({
                  ...scrollTableParams,
                  cellId: getCellId(),
                  direction: DIRECTIONS.RIGHT,
                  toTheEnd: true,
                });
              }
            }
            break;
          case 'ArrowRight':
            if (currentFieldIndex < fields.length - 1) {
              fieldCompositeKey = event.metaKey
                ? fields[fields.length - 1]
                : fields[currentFieldIndex + 1];
              this.scrollTableHandler({
                ...scrollTableParams,
                cellId: getCellId(),
                direction: DIRECTIONS.RIGHT,
                toTheEnd: event.metaKey,
              });
            } else {
              fieldCompositeKey = event.metaKey ? fields[fields.length - 1] : fields[0];
              if (!event.metaKey) {
                this.scrollTableHandler({
                  ...scrollTableParams,
                  cellId: getCellId(),
                  direction: DIRECTIONS.LEFT,
                  toTheEnd: true,
                });
              }
            }
            break;
        }
      }
      switch (event.key) {
        case 'ArrowUp':
          if (currentRowIndex >= 1) {
            rowIdCompositeKey = event.metaKey ? rowsIds[0] : rowsIds[currentRowIndex - 1];
            this.scrollTableHandler({
              ...scrollTableParams,
              cellId: getCellId(),
              direction: DIRECTIONS.UP,
            });
          } else {
            rowIdCompositeKey = event.metaKey ? rowsIds[0] : rowsIds[rowsIds.length - 1];
            if (!event.metaKey) {
              this.scrollTableHandler({
                ...scrollTableParams,
                cellId: getCellId(),
                direction: DIRECTIONS.DOWN,
                toTheEnd: true,
              });
            }
          }
          break;
        case 'ArrowDown':
          if (currentRowIndex < rowsIds.length - 1) {
            rowIdCompositeKey = event.metaKey
              ? rowsIds[rowsIds.length - 1]
              : rowsIds[currentRowIndex + 1];
            this.scrollTableHandler({
              ...scrollTableParams,
              cellId: getCellId(),
              direction: DIRECTIONS.DOWN,
            });
          } else {
            rowIdCompositeKey = event.metaKey ? rowsIds[rowsIds.length - 1] : rowsIds[0];
            if (!event.metaKey) {
              this.scrollTableHandler({
                ...scrollTableParams,
                cellId: getCellId(),
                direction: DIRECTIONS.UP,
                toTheEnd: true,
              });
            }
          }
          break;
        case 'Tab':
        case 'Enter':
          // Двигаемся вправо если возможно, переходим в начало, если таблица закончилась, иначе меняем строку
          if (currentFieldIndex < fields.length - 1) {
            fieldCompositeKey = fields[currentFieldIndex + 1];
            this.scrollTableHandler({
              ...scrollTableParams,
              cellId: getCellId(),
              direction: DIRECTIONS.RIGHT,
            });
          } else if (
            currentRowIndex === rowsIds.length - 1 &&
            currentFieldIndex === fields.length - 1
          ) {
            fieldCompositeKey = fields[0];
            rowIdCompositeKey = rowsIds[0];
            this.scrollTableHandler({
              ...scrollTableParams,
              cellId: getCellId(),
              direction: DIRECTIONS.UP,
              toTheEnd: true,
            });
            this.scrollTableHandler({
              ...scrollTableParams,
              cellId: getCellId(),
              direction: DIRECTIONS.LEFT,
              toTheEnd: true,
            });
          } else if (currentRowIndex < rowsIds.length - 1) {
            fieldCompositeKey = fields[0];
            rowIdCompositeKey = rowsIds[currentRowIndex + 1];
            this.scrollTableHandler({
              ...scrollTableParams,
              cellId: getCellId(),
              direction: DIRECTIONS.DOWN,
            });
            this.scrollTableHandler({
              ...scrollTableParams,
              cellId: getCellId(),
              direction: DIRECTIONS.LEFT,
              toTheEnd: true,
            });
          }
          break;
      }
      return `${+isBreakdown}${fieldCompositeKey}${rowIdCompositeKey}`;
    },
    // Функция вычисляет на какой ячейке дальше нужно сфокусироваться в зависимости от нажатых кнопок
    // rowsIds: список айдишников строк, по которым можно осуществлять навигацию
    // fields: список столбиков, по которым можно осуществлять навигацию
    // currentRowId: где произошло событие (строка), нужно для определение откуда нужно переместиться
    // currentField: где произошло событие (столбик), нужно для определение откуда нужно переместиться
    // Возвращает адрес новой локации
    async keydownCellValueMixinHandler(
      event,
      {
        rowsIds = [],
        fields = [],
        currentRowId,
        currentField,
        isBreakdown = false,
        value = '',
        currentCellId = '',
        tableId,
      }
    ) {
      await this.keydownCellValue(event);
      let newCellId = '';
      if (this.NAVIGATION_BUTTONS_KEY_CODES.includes(event.keyCode)) {
        newCellId = await this.getNextPositionIdByLocationAndEvent({
          event,
          rowsIds,
          fields,
          currentRowId,
          currentField,
          isBreakdown,
          value,
          tableId,
        });
        this.showDropdown = false;
      }
      if (newCellId && currentCellId !== newCellId) {
        event.preventDefault();
      }
      return newCellId;
    },
  },
};

export default tableNavigation;
